import Layout from "../components/Layout";
import { PaymentBlotter } from "../components/_PaymentBillingBlotter/PaymentBlotter";

const PaymentBlotterPage = (props: any) => {
    return (
        <Layout>
            <PaymentBlotter />
        </Layout>
    )
}

export default PaymentBlotterPage